export const FACILITY_STATUS = {
  ANY: 0,
  IS_VERIFIED: "is_verified",
  IS_UNVERIFIED: "is_unverified",
  IS_DUPLICATE: "is_duplicate",
  HAS_PENDING_VERIFICATION: "has_pending_verification",
  IS_INACTIVE: "is_inactive"
};

export const LOCATION_STATE_CODE = {
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error"
};

export const BING_FACILITY_STATUS = {
  ANY: 0,
  NO_CONNECTION: "no_connection",
  CONNECTION_ACTIVE: "connection_is_active",
  PUBLISHING_IN_PROGRESS: "publishing_in_progress",
  PUBLISHING_FAILED: "publishing_of_information_failed",
  CREATION_IN_PROGRESS: "creation_in_progress"
};
